import React, {
    useState,
    useEffect,
    useRef,
    createContext,
    useContext,
} from "react";

import LoadingSpinnerImage from "../Shared/LoadingSpinnerImage.js";


const Admin = ({ submissionId, currentCountryRepresentativeEmail }) => {

    const [adminRecord, setAdminRecord] = useState([]);
    const [isLoadingObjects, setIsLoadingObjects] = useState(false);
    const [isInvitingCR, setIsInvitingCR] = useState(true);
    const [invitedCR, setInvitedCR] = useState(false);
    const [failedInvitingCR, setFailedInvitingCR] = useState(false);
    const [removingAccessId, setRemovingAccessId] = useState(null);

    useEffect(() => {

        loadObjects();

    }, []);


    const loadObjects = () => {

        setIsLoadingObjects(true);


        let loadObjectsURL = `/umbraco/api/Submission/Users?id=${submissionId}&`;

        let requestOptions = {};

        fetch(loadObjectsURL, requestOptions)
            .then((response) => {
                if (!response.ok) {
                    if (response.status === 401)
                        document.dispatchEvent(new Event("api:unauthorized"));

                    setHasMoreComments(false);
                    throw new Error("Network response was not ok");
                }
                return response.json();
            })
            .then((data) => {
                setAdminRecord(data);


                let currentRepresentativeEmailInvitedAlready = data.find((member) => member.Email == currentCountryRepresentativeEmail);

                setIsInvitingCR(false);

                if (currentRepresentativeEmailInvitedAlready) {
                    setInvitedCR(true);
                }

            })
            .catch((error) => {
            })
            .finally(() => {
                setIsLoadingObjects(false);
            });
    };

    
    const inviteCR = () => {

        
        let inviteURL =
            `/umbraco/api/Submission/Users?` +
            `id=${submissionId}&`;

        const requestOptions = {
            method: "POST",
            headers: { "Content-Type": "application/json" },
        };

        setIsInvitingCR(true);

        fetch(inviteURL, requestOptions)
            .then((response) => {
                if (!response.ok) {
                    if (response.status === 401)
                        document.dispatchEvent(new Event("api:unauthorized"));

                    setHasMoreComments(false);
                    throw new Error("Network response was not ok");
                }
                return response.json();
            })
            .then((data) => {
                loadObjects();
            })
            .catch((error) => {
            })
            .finally(() => {
                setIsInvitingCR(false);
            });




        setInvitedCR(true);

    }


    const removeAccess = (memberId) => {

        
        let removeURL =
            `/umbraco/api/Submission/Users?` +
            `id=${submissionId}&` + 
            `memberId=${memberId}&` + 
            `link=false`;

        const requestOptions = {
            method: "POST",
            headers: { "Content-Type": "application/json" },
        };

        setRemovingAccessId(memberId);

        fetch(removeURL, requestOptions)
            .then((response) => {
                if (!response.ok) {
                    if (response.status === 401)
                        document.dispatchEvent(new Event("api:unauthorized"));

                    setHasMoreComments(false);
                    throw new Error("Network response was not ok");
                }
                return response.json();
            })
            .then((data) => {

                setAdminRecord(prev => prev.filter(member => member.Id != memberId));

            })
            .catch((error) => {
            })
            .finally(() => {
                setIsInvitingCR(false);
                setRemovingAccessId(null);
            });

        

        

    }





    

    return (<>
        <div style={{ marginTop: "20px", marginBottom: "20px" }}>
            <div>All company users plus the following guest members have access to this submission:</div>
        {isInvitingCR ? <>
            <div style={{ display: "flex", textAlign: "center", justifyContent: "center", alignItems: "center", minWidth: "150px" }}>
                <LoadingSpinnerImage />
            </div>
            </> : <>
           
                <div style={{ display: "flex", textAlign: "center", justifyContent: "right", alignItems: "center", minWidth: "150px", minHeight: "40px" }}>
                        {invitedCR ?
                            <>
                                <span style={{fontWeight: "600"} }>Current Country Representative was invited to access.</span>
                            </>
                            : failedInvitingCR ?
                                <>
                            <span>Current Country Representative was already invited.</span>
                                </>
                                :
                            <div>
                                <span className="invite-country-representative" onClick={inviteCR}>
                                    <i className="fas fa-user-plus g-mr-5"></i>
                                    Invite current Country Representative
                                </span>
                            </div>
                    }
                </div>
          
        </>}
        </div>

        {/* Audit list */}


        {isLoadingObjects ? <>
            <div>
                <LoadingSpinnerImage />
            </div>
        </> : <>


            <table className = "results-table" style ={ { width: "100%" } }>
                <thead>
                    <tr style ={ { borderBottom: "1px solid #f0f0f0"} }>
                        <th style ={ { width: "45%" } }> Guest Name </th>
                        <th style ={ { width: "40%" } }> Email </th>
                        <th style ={ { width: "15%" } }> Actions </th>
                    </tr>
                </thead>
                <tbody>
                    {adminRecord.length > 0 ? (
                        adminRecord.map((member, index) => {

                            let memberId = member.Id;
                            let name = member.Name;
                            let email = member.Email;

                            return <tr key={index} style={{ borderBottom: "1px solid #f0f0f0" }}>
                                <td>{name}</td>
                                <td>{email}</td>
                                <td>
                                    {removingAccessId == memberId ?
                                        <div><LoadingSpinnerImage /></div>
                                        : 
                                        <span className="remove-country-representative" onClick={() => removeAccess(memberId)}>Remove access</span>
                                    }
                                </td>
                            </tr>
                        })
                    ) : (
                    <tr>
                      <td colSpan="3" style={{ textAlign: "center", padding: "8px" }}>
                        No invites found
                      </td>
                    </tr>
                  )}
                </tbody>
            </table>

            



        </>}


        <div style={{ minHeight: "20px" }}></div>

    </>);

};



export default Admin;